import { keyBy } from 'lodash';

const blockSites = {
    id: 'performance.rule.executed.actions.report.actionType.details.BLOCK_SITES',
    defaultMessage: '{name} - ({id})',
};

const pauseAds = {
    id: 'performance.rule.executed.actions.report.actionType.details.PAUSE_AD',
    defaultMessage: '{name} ID: {id}',
};

const increaseDailyBudgetPercent = {
    id: 'performance.rule.executed.actions.report.actionType.details.INCREASE_DAILY_BUDGET.PERCENT',
    defaultMessage: 'Daily budget increased by {changeValue}%',
};

const increaseDailyBudgetCurrency = {
    id: 'performance.rule.executed.actions.report.actionType.details.INCREASE_DAILY_BUDGET.CURRENCY',
    defaultMessage: 'Daily budget increased by $ {changeValue}',
};

const decreaseDailyBudgetPercent = {
    id: 'performance.rule.executed.actions.report.actionType.details.DECREASE_DAILY_BUDGET.PERCENT',
    defaultMessage: 'Daily budget decreased by {changeValue}%',
};

const decreaseDailyBudgetCurrency = {
    id: 'performance.rule.executed.actions.report.actionType.details.DECREASE_DAILY_BUDGET.CURRENCY',
    defaultMessage: 'Daily budget decreased by $ {changeValue}',
};

const activityDetailsOptions = [
    blockSites,
    pauseAds,
    increaseDailyBudgetCurrency,
    increaseDailyBudgetPercent,
    decreaseDailyBudgetCurrency,
    decreaseDailyBudgetPercent,
];

export const ActivityDetailsByActionType = keyBy(activityDetailsOptions, 'id');
